module.exports = __webpack_public_path__ + "static/img/RK964-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RK964-G_1.png
// module id = vjtu
// module chunks = 0